<script>
  import IntersectionObserver from "svelte-intersection-observer";

  let element;
  let intersecting;

  import Emoji from "@helpers/Emoji.svelte";
  import navigateToHash from "@helpers/navigateToHash.js";
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element}>
    <h1 class="section-title">
      <span class="emoji-follows" data-emoji="👋">
        <Emoji emoji="wave" styles="top: -70%; left: -50%;" />
        Get
      </span>
      to know the <span class="accent-text">Houston Budget.</span>
    </h1>
    <p class="subtitle">
      The city budget is <strong>complicated</strong>. It can feel abstract and
      unclear.
    </p>
    <p class="tertiary-title">
      It <strong>should</strong> be a tool for Houstonians to
      <strong>get the services they need</strong>.
    </p>
    <p
      class="direction-text"
      on:click={() => {
        navigateToHash("introduction", 0);
      }}
    >
      <!-- By the end of this guide, we want you to feel confident talking about the
      budget and what you would like more support for! -->
      Use this tool to learn about the budget and build support for what you want
      to see in it!
    </p>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: center;
    padding: 1rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    min-height: calc(93.5vh - var(--nav-height));
    margin-top: var(--nav-height);
  }

  .direction-text {
    max-width: 568px;
    margin: 2rem auto;
    cursor: pointer;
  }

  h1 {
    font-size: 5rem;
    font-weight: 800;
    padding-bottom: 0.75rem;
    max-width: 968px;
    margin-bottom: 2.5rem;
    position: relative;
  }

  .subtitle {
    font-size: 1.7rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 2rem;
    color: rgba(var(--text-color-rgb), 0.75);
  }

  .tertiary-title {
    font-size: 1.425rem;
    margin-bottom: 1rem;
    font-weight: 500;
    line-height: 1.25;
    color: rgba(var(--text-color-rgb), 0.75);
  }

  .emoji-follows:before {
    top: -1rem;
    left: -5.5rem;
  }

  @media screen and (max-width: 568px) {
    section {
      margin-top: 40px;
      min-height: calc(92.5vh - 40px);
      padding: 1rem 1.75rem;
    }
    h1 {
      font-size: 3rem;
      margin-bottom: 1.5rem;
    }
    .direction-text {
      font-size: 1rem;
    }
  }
</style>
